<template>
  <div style="overflow:hidden">
    <dashboard-core-app-bar />
    <v-dialog v-model="processPaymentDialog">
      <ProcessPaymentDialog />
    </v-dialog>
    <BodyContainer
      :id="'orders'"
      v-if="this.$vuetify.breakpoint.name=='xs'  || this.$vuetify.breakpoint.name=='sm' "
    >
      <div v-if="orders" fluid class="d-flex flex-column flex-md-row flex-lg-row flex-xl-row">
        <v-tabs v-model="tab" background-color="transparent" grow show-arrows>
          <v-tab v-for="orderStatus in orderStatusTypes" :key="orderStatus">
            <div class="d-flex justify-space-between">
              <h3 class="mb-3">{{ $t(orderStatus) }}</h3>
              <v-btn
                v-if="selectedStatus && selectedStatus === orderStatus"
                text
                :color="colorBySelectedStatus"
                @click.prevent="selectedProducts = {}"
              >{{ $t("Unselect all") }}</v-btn>
            </div>
          </v-tab>
          <v-tab-item v-for="orderStatus in orderStatusTypes" :key="orderStatus">
            <BodyCard :outlined="false" height="70vh" style="overflow:hidden">
              <v-container style="overflow:hidden">
                <v-card flat height="60vh" style="overflow: auto">
                  <Order
                    v-for="order in ordersWithStatus(orderStatus)"
                    :key="order.id"
                    class="my-4"
                    :order="order"
                    :currentTime="currentTime"
                    :filterStatus="orderStatus"
                    :selectedProducts="selectedProducts[order.id]"
                    @orderClicked="
                    (isNext, selectedWrappers) =>
                      onOrderClicked(isNext, selectedWrappers, filterStatus)
                  "
                    @openPaymentDialog="onOpenPaymentDialog"
                    @productSelected="onProductSelected"
                  />
                </v-card>

                <v-dialog v-model="orderDetailsDialog" width="70vw">
                  <OrderDialog
                    :order="selectedOrder"
                    :location="dialogOrderLocation"
                    @openPaymentDialog="onOpenPaymentDialog"
                  />
                </v-dialog>
              </v-container>
            </BodyCard>
          </v-tab-item>
        </v-tabs>
      </div>
    </BodyContainer>
    <BodyContainer :id="'orders'" v-else>
      <div v-if="orders" fluid class="d-flex flex-column flex-md-row flex-lg-row flex-xl-row">
        <v-col
          md-cols="4"
          lg-cols="4"
          xl-cols="4"
          v-for="orderStatus in orderStatusTypes"
          :key="orderStatus"
        >
          <BodyCard :outlined="false" height="70vh" style="overflow:hidden">
            <v-container style="overflow:hidden">
              <div class="d-flex justify-space-between">
                <h3 class="headline mb-3">{{ $t(orderStatus) }}</h3>
                <v-btn
                  v-if="selectedStatus && selectedStatus === orderStatus"
                  text
                  :color="colorBySelectedStatus"
                  @click="selectedProducts = {}"
                >{{ $t("Unselect all") }}</v-btn>
              </div>
              <v-card flat height="60vh" style="overflow: auto">
                <Order
                  v-for="order in ordersWithStatus(orderStatus)"
                  :key="order.id"
                  class="my-4"
                  :order="order"
                  :currentTime="currentTime"
                  :filterStatus="orderStatus"
                  :selectedProducts="selectedProducts[order.id]"
                  @orderClicked="
                    (isNext, selectedWrappers) =>
                      onOrderClicked(isNext, selectedWrappers, filterStatus)
                  "
                  @openPaymentDialog="onOpenPaymentDialog"
                  @productSelected="onProductSelected"
                />
              </v-card>

              <v-dialog v-model="orderDetailsDialog" width="70vw">
                <OrderDialog
                  :order="selectedOrder"
                  :location="dialogOrderLocation"
                  @openPaymentDialog="onOpenPaymentDialog"
                />
              </v-dialog>
            </v-container>
          </BodyCard>
        </v-col>
      </div>
      <div v-else></div>
    </BodyContainer>
    <v-dialog v-model="paymentDialog">
      <v-card flat class="pa-8">
        <div class="headline my-4">
          {{
          paymentMovement === "confirmPayment"
          ? $t("Confirm order payment?")
          : $t("Cancel order payment?")
          }}
        </div>
        <TicketOrder :toPayOrders="toPayOrders" />

        <v-card-actions>
          <v-spacer />
          <v-btn text @click="closePaymentDialog" class="mr-4">
            {{
            $t("Cancel")
            }}
          </v-btn>
          <v-btn text @click="updatePayment(toPayOrders)">
            {{
            paymentMovement === "confirmPayment"
            ? $t("Confirm payment")
            : $t("Cancel payment")
            }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="pendingOrdersDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <PendingOrdersDialog @close="closePendingOrdersDialog" />
    </v-dialog>

    <v-footer inset color="background" fixed app>
      <v-row justify="center" align="center" class="my-4">
        <v-btn
          x-large
          icon
          v-if="selectedProductsCount"
          :disabled="isFirstStage"
          @click="moveSelected(false)"
        >
          <v-icon v-if="!isFirstStage" x-large :color="colorBySelectedStatus">
            {{
            selectedProductsCount > 1
            ? "mdi-chevron-double-left"
            : "mdi-chevron-left"
            }}
          </v-icon>
        </v-btn>
        <v-btn
          icon
          x-large
          outlined
          @click="openPendingOrdersDialog"
          :color="pendingOrdersCount ? 'primary' : null"
          class="title mx-4"
          style="border-width: 2px; font-weight: bold;"
        >{{ pendingOrdersCount }}</v-btn>
        <v-btn
          x-large
          icon
          v-if="selectedProductsCount"
          :disabled="isFinalStage"
          @click="moveSelected(true)"
        >
          <v-icon v-if="!isFinalStage" x-large :color="colorBySelectedStatus">
            {{
            selectedProductsCount > 1
            ? "mdi-chevron-double-right"
            : "mdi-chevron-right"
            }}
          </v-icon>
        </v-btn>
      </v-row>
    </v-footer>
  </div>
</template>

<script>
import { OrderProductStatus } from "@/model/order";
import ProcessPaymentDialog from "@/views/dashboard/components/orders/ProcessPaymentDialog";
import PendingOrdersDialog from "@/views/dashboard/components/orders/PendingOrdersDialog";
import Order from "@/views/dashboard/components/orders/Order";
import OrderDialog from "@/views/dashboard/components/orders/OrderDialog";
import TicketOrder from "@/views/dashboard/components/orders/TicketOrder";

export default {
  data() {
    return {
      orderStatusTypes: [
        OrderProductStatus.preparing,
        OrderProductStatus.ready,
        OrderProductStatus.delivered
      ],
      processPaymentDialog: false,
      currentTime: new Date(),
      orderDetailsDialog: false,
      paymentDialog: false,
      paymentMovement: null,
      selectedOrder: null,
      selectedStatus: null,
      selectedHasBeenPaid: null,
      selectedProducts: {},
      pendingOrdersDialog: false,
      toPayOrders: []
    };
  },

  components: {
    BodyCard: () => import("../components/BodyCard"),
    BodyContainer: () => import("../components/BodyContainer"),
    DashboardCoreAppBar: () =>
      import("@/views/dashboard/components/core/AppBar"),
    // OrderList: () => import("../components/orders/OrderList"),
    Order,
    OrderDialog,
    ProcessPaymentDialog,
    PendingOrdersDialog,
    TicketOrder
  },

  computed: {
    orders() {
      return this.$store.getters.orders;
    },

    pendingOrdersCount() {
      return this.ordersWithStatus(OrderProductStatus.pending).length;
    },

    dialogOrderLocation() {
      return this.selectedOrder
        ? this.$store.getters.locations.find(
            location => location.id === this.selectedOrder.location
          )
        : null;
    },

    selectedProductsCount() {
      let count = 0;
      for (let key in this.selectedProducts) {
        count += this.selectedProducts[key].length;
      }
      return count;
    },

    isFirstStage() {
      return this.selectedStatus === OrderProductStatus.preparing;
    },

    isFinalStage() {
      return (
        this.selectedStatus === OrderProductStatus.delivered &&
        this.selectedHasBeenPaid
      );
    },

    colorBySelectedStatus() {
      switch (this.selectedStatus) {
        case OrderProductStatus.preparing:
          return "#e35252";
        case OrderProductStatus.ready:
          return "#50c79b";
        case OrderProductStatus.delivered:
          return this.selectedHasBeenPaid ? "#d1d1d1" : "#33a7ff";
      }
      return "#d1d1d1";
    }
  },

  methods: {
    openPendingOrdersDialog() {
      this.pendingOrdersDialog = true;
    },

    closePendingOrdersDialog() {
      this.pendingOrdersDialog = false;
    },

    ordersWithStatus(status) {
      // TODO switch(status) => sortAndFilter${Status}()
      return this.orders.filter(order => {
        // If pending
        if (!order.products) return false;

        return order.products.some(product => product.status === status);
      });
    },

    onOrderClicked(order) {
      this.orderDetailsDialog = true;
      this.selectedOrder = order;
    },
    ordersByUser(user) {
      return this.orders.filter(order => {
        if (!order.userId) return false;
        return order.userId === user;
      });
    },
    onOpenPaymentDialog(paymentMovement, order) {
      if (order) {
        this.toPayOrders = this.ordersByUser(order.userId);
      }
      this.paymentDialog = true;
      this.paymentMovement = paymentMovement;
    },

    updatePayment(toPayOrders) {
      toPayOrders.forEach(order => {
        order.hasBeenPaid = this.paymentMovement === "confirmPayment";
        order.save();
      });
      this.cancelSelection();
      this.closePaymentDialog();
    },

    closePaymentDialog() {
      this.paymentDialog = false;
      this.paymentMovement = null;
      if (!this.orderDetailsDialog) {
        this.selectedOrder = null;
      }
    },

    onProductSelected(orderId, productIndex) {
      if (
        this.selectedProducts[orderId] &&
        this.selectedProducts[orderId].some(index => index === productIndex)
      ) {
        // Unselect product
        this.selectedProducts[orderId] = this.selectedProducts[orderId].filter(
          index => index !== productIndex
        );
        if (!this.selectedProducts[orderId].length) {
          // Cancel selection if last product
          delete this.selectedProducts[orderId];
          if (!Object.keys(this.selectedProducts).length) {
            this.cancelSelection();
          }
        }
      } else {
        let order = this.orders.find(order => order.id === orderId);
        let product = order.products[productIndex];
        // Check selection constraints
        let isSelectable = !(
          product.status === OrderProductStatus.delivered && order.hasBeenPaid
        );
        let isValidStatus =
          !this.selectedStatus ||
          (product.status === this.selectedStatus &&
            this.selectedHasBeenPaid === order.hasBeenPaid);

        if (isSelectable && isValidStatus) {
          this.selectedStatus = product.status;
          this.selectedHasBeenPaid = order.hasBeenPaid;
          if (!this.selectedProducts[orderId]) {
            this.selectedProducts[orderId] = [];
          }
          this.selectedProducts[orderId].push(productIndex);
        }
      }
      this.selectedProducts = { ...this.selectedProducts };
    },

    moveSelected(toNext) {
      let to = OrderProductStatus[toNext ? "next" : "previous"](
        this.selectedStatus
      );

      if (to && !this.isFinalStage) {
        // to should never be null
        for (let orderId in this.selectedProducts) {
          let order = this.orders.find(order => order.id === orderId);
          let selectedWrappers = this.selectedProducts[orderId].map(index => {
            return { product: order.products[index], index: index };
          });
          order.updateProductsStatus(this.selectedStatus, to, selectedWrappers);
        }
        this.cancelSelection();
      }
    },

    cancelSelection() {
      this.selectedStatus = null;
      this.selectedHasBeenPaid = null;
      this.selectedProducts = {};
    }
  },
  created() {
    let self = this;
    setInterval(() => (self.currentTime = new Date()), 6000);
  },
  beforeMount() {
    if (!this.$store.getters.accountType) {
      this.$router.replace("/signup");
    }
    if (this.$store.getters.accountType == "basic") {
      this.$router.replace("/products");
    }
  }
};
</script>